import(/* webpackMode: "eager" */ "/codebuild/output/src1178871307/src/scaleup-applications/apps/scaleup-platform-ui/app/layout.tsx");
